import { alpha, PaletteOptions } from '@mui/material';

export const darkPalette: PaletteOptions = {
  mode: 'dark',

  orange: {
    main: '#FFA723',
    dark: '#FFA723',
    light: '#FFA723',
    contrastText: '#0D0D0D',
  },

  primary: {
    main: '#FF6039',
    dark: '#FE2368',
    light: '#E1E9FD',
    contrastText: '#ffffff',
  },

  secondary: {
    main: alpha('#FFF', 0.05),
    dark: alpha('#FFF', 0.05),
    light: alpha('#FFF', 0.1),
    contrastText: '#fff',
  },

  info: {
    main: '#FFFFFF',
    dark: '#CFCFCF',
    light: '#E7E7E7',
    contrastText: '#0D0D0D',
  },

  error: {
    main: '#E00000',
    dark: '#E00000',
    light: alpha('#FE2368', 0.15),
    contrastText: '#FE2368',
  },

  warning: {
    main: alpha('#FF8020', 0.15),
    dark: alpha('#FF8020', 0.15),
    light: alpha('#FF8020', 0.15),
    contrastText: '#FF8020',
  },

  success: {
    main: alpha('#23FF70', 0.15),
    dark: alpha('#23FF70', 0.15),
    light: alpha('#23FF70', 0.15),
    contrastText: '#23FF70',
  },

  background: {
    default: '#0D0D0D',
    paper: alpha('#FFF', 0.05),
  },

  grey: {
    100: '#42464F',
    200: '#A3A3A3',
    300: '#191919',
    400: '#A7AFC0',
    500: '#9AA1B0',
    600: '#82899A',
    700: '#333333',
    800: '#333333',
    900: '#FFFFFF',
  },

  text: {
    primary: '#fff',
    secondary: alpha('#fff', 0.6),
    disabled: alpha('#0D0D0D', 0.2),
  },

  divider: '#42464F',

  common: {
    black: '#000000',
    white: '#ffffff',
  },
};
